// Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './imageSplitView.scss';

const ImageSplitView = ({ children, splitImg, altTitle }) => (
    <div className="image-split-view-wrapper">
        <div className="view-content">{children}</div>
        <div className="view-img-wrapper">
            <img src={splitImg} alt={altTitle} />
        </div>
    </div>
);

ImageSplitView.propTypes = {
    altTitle: PropTypes.string,
    children: PropTypes.node,
    splitImg: PropTypes.node,
};

export default ImageSplitView;
